// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import store from './stores'
import App from './App'
import router from './router'
import * as filters from './filters'
import '@/permission' // permission control
import 'default-passive-events'  //解决谷歌浏览器滚动条流畅警告问题


import VueWechatTitle from 'vue-wechat-title' // 更改浏览器title的插件

import {
  Tree,
  Select,
  Input,
  Upload,
  Option,
  Scrollbar,
  DatePicker,
  Pagination,
  Progress,
  Table,
  TableColumn,
  Tabs,
  TabPane,
  Button,
  Notification,
  MessageBox,
  Message,
  Alert,
  Loading,
  Radio,
  Tag,
  Cascader,
  Popover,
  Image,
  Checkbox,
  CheckboxGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Collapse,
  CollapseItem,
  Menu,
  Submenu,
  MenuItem,
  Dialog,
  RadioGroup,
  Tooltip,
  Form,
  FormItem,
  Carousel,
  CarouselItem,
  Switch,
  ColorPicker
} from 'element-ui'


import './static/element/theme/index.css'  //更换主题颜色
Vue.use(Tree)
Vue.use(Select)
Vue.use(Input)
Vue.use(Upload)
Vue.use(Option)
Vue.use(Scrollbar)
Vue.use(DatePicker)
Vue.use(Pagination)
Vue.use(Progress)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Button)
Vue.use(Alert)
Vue.use(Loading)
Vue.use(Radio)
Vue.use(Tag)
Vue.use(Cascader)
Vue.use(Popover)
Vue.use(Image)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Dialog)
Vue.use(RadioGroup)
Vue.use(Tooltip)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Switch)
Vue.use(ColorPicker)

Vue.use(VueWechatTitle)
Vue.prototype.$notify = Notification
Vue.prototype.$message = MessageBox
Vue.prototype.$msg = Message
Vue.prototype.$confirm = MessageBox.confirm

Vue.config.productionTip = false
// 注册filter
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

window.eventButtonBus = new Vue()

import './styles/common.styl'
/* eslint-disable no-new */
const vRouter = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  data: {
    eventHub: new Vue() // global event bus
  },
  template: '<App/>'
})

Vue.use({
  vRouter
})
